import {createContext, useContext} from 'react';
import {RfcAttachmentType} from '@common/types/rfc';

export interface RfcAttachmentItem {
  id: string;
  fileName: string;
  fileSize: number;
  fileType: RfcAttachmentType;
}

export interface RfcContextValue {
  accessToken: string;
  password: string;
  section125FormEnabled: boolean;
  mecFormEnabled: boolean;
  attachments?: RfcAttachmentItem[];
  refreshAttachments?: () => void;
  /** Persists the current form values as a draft (no step change). */
  saveDraft?: () => Promise<void>;
}

export const RfcContext = createContext<RfcContextValue | null>(null);

export function useRfcContext() {
  const context = useContext(RfcContext);
  if (!context) {
    throw new Error('useRfcContext must be used within RfcContext.Provider');
  }
  return context;
}
